import { Routes } from '@angular/router';

import { AddStateComponent } from '../../manage-states/add-state/add-state.component';
import { ViewStatesComponent } from '../../manage-states/view-states/view-states.component';
import { AddDistrictsComponent } from '../../manage-district/add-districts/add-districts.component';
import { AddMunicipalityComponent } from '../../manage-municipality/add-municipality/add-municipality.component';
import { AdPlansComponent } from '../../ad-plans/ad-plans.component';
import { ViewDistrictsComponent } from '../../manage-district/view-districts/view-districts.component';
import { ViewMunicipalitiesComponent } from '../../manage-municipality/view-municipalities/view-municipalities.component';
import { ViewAdPlansComponent } from '../../manage-ad-plans/view-ad-plans/view-ad-plans.component';
import { ViewUsersComponent } from '../../manageusers/view-users/view-users.component';
import { AddBlogComponent } from '../../manage-blogs/add-blog/add-blog.component';
import { AddPropertyTypeComponent } from 'app/manage-property-types/add-property-type/add-property-type.component';
import { ViewPropertyTypeComponent } from 'app/manage-property-types/view-property-type/view-property-type.component';
import { EditBlogComponent } from 'app/manage-blogs/edit-blog/edit-blog.component';
import { ViewBlogsComponent } from 'app/manage-blogs/view-blogs/view-blogs.component';
import { ManageRoadBlocksComponent } from 'app/manage-road-blocks/manage-road-blocks.component';
import { ManageLocalAdsComponent } from 'app/manage-local-ads/manage-local-ads.component';
import { VerifyBankPaymentsComponent } from 'app/verify-bank-payments/verify-bank-payments.component';
import { VerifyBankTransferComponent } from 'app/verify-bank-transfer/verify-bank-transfer.component';
import { AdPlanResolverService } from 'app/resolver/ad-plan-resolver.service';
import { ManageBannerImagesComponent } from 'app/manage-banner-images/manage-banner-images.component';
import { DashboardComponent } from 'app/dashboard/dashboard.component';
import { ManagePropertiesComponent } from 'app/manage-properties/manage-properties.component';
import { EsewaComponent } from 'app/esewa/esewa.component';
import { CashPaymentsComponent } from 'app/cash-payments/cash-payments.component';
import { ProfileComponent } from 'app/profile/profile.component';
import { EditProperyTypeComponent } from 'app/components/edit-propery-type/edit-propery-type.component';
import { EditPropertyComponent } from 'app/edit-property/edit-property.component';
import { ProvinceResolverService } from 'app/resolver/province-resolver.service';
import { DistrictResolverService } from 'app/resolver/district-resolver.service';
import { MunicipalityResolverService } from 'app/resolver/municipality-resolver.service';
import { PropertyTypeResolverService } from 'app/resolver/property-type-resolver.service';
import { PropertyResolverService } from 'app/resolver/property-resolver.service';

export const AdminLayoutRoutes: Routes = [
    { path: '', component: DashboardComponent},
    { path: 'state/add', component:AddStateComponent},
    { path: 'profile', component: ProfileComponent},
    { path: 'state/view', component:ViewStatesComponent },
    { path: 'district/add', component:AddDistrictsComponent },
    { path: 'district/view', component:ViewDistrictsComponent },
    { path: 'municipality/add', component:AddMunicipalityComponent },
    { path: 'municipality/view', component: ViewMunicipalitiesComponent},
    { path: 'ad-plans/add', component:AdPlansComponent},
    { path: 'ad-plans/view', component:ViewAdPlansComponent },
    { path: 'property-type/add', component:AddPropertyTypeComponent},
    { path: 'property-type/view', component:ViewPropertyTypeComponent },
    { path: 'users/view', component:ViewUsersComponent },
    { path: 'blog/add', component: AddBlogComponent},
    { path: 'blog/edit/:id', component: EditBlogComponent},
    { path: 'blog/view', component: ViewBlogsComponent},
    { path: 'banner-image',component: ManageBannerImagesComponent},
    { path: 'road-block',component: ManageRoadBlocksComponent},
    { path: 'local-ad',component: ManageLocalAdsComponent},
    { path: 'verify-bank-voucher',component: VerifyBankPaymentsComponent, resolve: { adPlans: AdPlanResolverService }},
    { path: 'verify-transaction',component: VerifyBankTransferComponent, resolve: { adPlans: AdPlanResolverService }},
    { path: 'esewa',component: EsewaComponent, resolve: { adPlans: AdPlanResolverService }},
    { path: 'cash-payments',component: CashPaymentsComponent, resolve: { adPlans: AdPlanResolverService }},
    { path: 'view-properties', component: ManagePropertiesComponent },
    { path: 'edit-property/:id', component: EditPropertyComponent, resolve: { 
        provinceList: ProvinceResolverService,
        districtList: DistrictResolverService,
        municipalityList: MunicipalityResolverService,
        adPlans: AdPlanResolverService,
        propertyTypes: PropertyTypeResolverService,
        propertyAd: PropertyResolverService
    }}
];
